// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"db9922d4","295":"edc80a0e","662":"860ed4f1"}[chunkId] + ".chunk.css";
};